import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useHistory } from "react-router-dom";
const MachineDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRegisterClick = () => {
    handleClose();
    history.push("/register-machine");
  };

  const handleMachineOverview = () => {
    handleClose();
    history.push("/machine-overview");
  };

  const handleRegisterDevice = () => {
    handleClose();
    history.push("/register-device");
  };

  const handleRegisterSIM = () => {
    handleClose();
    history.push("/register-sim");
  };

  return (
    <div>
      <Button
        id="machine-button"
        aria-controls={open ? "machine-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Machine
      </Button>
      <Menu
        id="machine-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "machine-button",
        }}
      >
        <MenuItem onClick={handleMachineOverview}>Machine Overview</MenuItem>
        <MenuItem onClick={handleRegisterSIM}>1).Register SIM</MenuItem>
        <MenuItem onClick={handleRegisterDevice}>2).Register Device</MenuItem>
        <MenuItem onClick={handleRegisterClick}>3).Register Machine</MenuItem>
      </Menu>
    </div>
  );
};

export default MachineDropdown;
